const getBlacklistPlayerItemAsHistoryItem = (
  players: BlacklistPlayer[]
): BlacklistPlayerHistoryItem[] =>
  players.map(player => ({
    created_at: player.last_modified_at || '',
    reason: player.reason,
    status: player.status,
    team: player.current_team,
    reporter: null,
    videogame_slug: player.current_videogame_slug,
    name: player.name
  }));

export { getBlacklistPlayerItemAsHistoryItem };
